/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';

import { NbIconLibraries } from '@nebular/theme';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private userIdle: UserIdleService,
    private router: Router,
    private iconLibraries: NbIconLibraries
  ) {


    this.iconLibraries.registerFontPack('ai-allergens', { iconClassPrefix: 'ai' });


  }

  ngOnInit() {
    this.analytics.trackPageViews();



    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      // console.log(count);
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {

      console.log('Time is up!');
      this.userIdle.resetTimer();
      this.userIdle.startWatching();
      const route = this.router.url;

      if (!route.includes("/signage")) {
        console.log('Go To Signage');
        this.router.navigate(['/signage/idle']);

      }


    });


  }
}
